import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import GatedForm, { propTypes } from './GatedForm';
import * as styles from './HeadingWithForm.module.css';

const defaultBackgroundImage = '/images/fs-landing-header-vertical-bars-pink.svg';

const HeadingWithForm = ({
  isSpark = false,
  title,
  superText,
  lede,
  excerpt,
  formData,
  headingFontColor,
  backgroundImageUrl,
  headingImage,
  availableForAll,
  onSuccess,
  id,
  trackingPixelUrl,
  downloadCtaLabel,
  uniqueTrackingPixel,
  //alreadySubmitted = false,
}) => {
  const [isAwardsPage, setIsAwardsPage] = useState(false);

  useEffect(() => {
    setIsAwardsPage(window.location.pathname.includes('nominate'));
  }, []);

  const fontClass = headingFontColor === 'Dark' ? '' : styles.lightFont;
  const imageData = get(formData, 'heroImage.gatsbyImageData');
  const img = get(formData, 'heroImage.file.url');
  let image;
  if (imageData) {
    image = (
      <GatsbyImage
        image={get(formData, 'heroImage.gatsbyImageData')}
        className={styles.heroImage}
        imgStyle={{ objectFit: 'contain' }}
        alt={title}
      />
    );
  } else if (img) {
    image = <img src={img} className={styles.heroImage} loading="lazy" alt={title} />;
  }

  return (
    <div
      className={[styles.container, isSpark && styles.sparkHeader, isAwardsPage && styles.sparkAwards].join(' ')}
      id={id}
    >
      <div
        className={styles.bg}
        style={{
          backgroundImage: `url("/images/fs-landing-arc.svg"), url("${backgroundImageUrl || defaultBackgroundImage}")`,
        }}
      />
      <div className={[styles.heading, fontClass].join(' ')}>
        {headingImage && <ContentfulImage imageFragment={headingImage} />}
        {!headingImage && (
          <>
            {superText && <span className={styles.superText}>{superText}</span>}
            <h1 className={styles.gatedH1}>{title}</h1>
            {lede && <p>{lede}</p>}
          </>
        )}
      </div>
      {!availableForAll && !isAwardsPage && (
        <div className={styles.form}>
          <GatedForm
            splitName={isSpark ? false : null}
            contentIsDownloadable={formData.contentIsDownloadable}
            successCopy={formData.successCopy}
            fileUrl={formData.fileUrl}
            heroImage={formData.heroImage}
            marketoFormId={formData.marketoFormId}
            dynamicForm={formData.dynamicForm}
            title={title}
            onSuccess={onSuccess}
            trackingPixelUrl={trackingPixelUrl}
            uniqueTrackingPixel={uniqueTrackingPixel}
            downloadCtaLabel={downloadCtaLabel}
            //forceSuccess={alreadySubmitted}
          />
        </div>
      )}
      {availableForAll && formData.heroImage && image}
      <div className={[styles.excerpt, availableForAll ? styles.expand : ''].join(' ')}>
        <RichTextConverter copy={excerpt} />
      </div>
    </div>
  );
};

HeadingWithForm.propTypes = {
  title: PropTypes.string.isRequired,
  superText: PropTypes.string,
  lede: PropTypes.string,
  headingFontColor: PropTypes.oneOf(['Dark', 'Light']),
  backgroundImageUrl: PropTypes.string,
  formData: PropTypes.shape({ ...propTypes }),
};

export default HeadingWithForm;
